<template>
    <div class="details">
        <i-row>
            <i-col span="24">
                <i-carousel autoplay loop>
                    <i-carouselItem v-for="item in slideDate">
                        <div class="carousel"><img class="carousel_img" :src="url + item.path"/></div>
                    </i-carouselItem>
                </i-carousel>
            </i-col>
        </i-row>
        <i-row class="margintop">
            <!--第六届大赛回顾-->
            <i-col span="24">
                <i-col span="24">
                    <div style="text-align: center">
                        <div>
                            <em class="line-r" style="width: 40%;left: 10px"></em>
                        </div>
                        <div>
                            <span class="title_head">{{ this.details.title }}</span>
                            <br/>
                            <span class="lang_eng">{{ this.details.englishtitle }}</span>
                        </div>
                        <div>
                            <em class="line-l" style="width: 40%;right: 10px !important;"></em>
                        </div>
                    </div>
                    <div style="text-align: center;padding:25px;width: 90%;margin: 0 auto">
                        <div v-html="this.details.content.details" style="text-align: left"></div>
                    </div>
                </i-col>
            </i-col>
        </i-row>
    </div>
</template>

<script>
    import {Icon, Col, Row, Carousel, CarouselItem, Breadcrumb, BreadcrumbItem, Menu, MenuGroup, MenuItem} from 'iview';
    import {api_getData} from '../../api/carousel';
    import {url} from '../../config';

    export default {
        name: '',
        components: {
            'i-col': Col,
            'i-row': Row,
            'i-icon': Icon,
            'i-carousel': Carousel,
            'i-carouselItem': CarouselItem,
            'i-breadcrumb': Breadcrumb,
            'i-breadcrumbItem': BreadcrumbItem,
            'i-menu': Menu,
            'i-menuGroup': MenuGroup,
            'i-menuItem': MenuItem,
        },
        data() {
            return {
                slideDate: [],
                url: url,
                details: {
                    content:'',
                    title:'',
                    englishtitle:''
                },
            }
        },
        async created() {
            this.details = JSON.parse(localStorage.getItem('details'));

            let _data = await api_getData('home');
            let res = _data.body;
            if (res.code === 0) {
                this.slideDate = res.data;
            }
        },
        mounted() {
            console.log(this.details)
        },
        methods: {}
    }
</script>

<style lang="scss">
    .details {
        text-align: left;
        /*轮播图设置*/
        .carousel {
            .carousel_img {
                width: 100%;
                height: 100%;
            }
        }

        /*row间距设置*/
        .margintop {
            margin-top: 20px;

            /*长线*/
            /*长线*/
            .line-l::after, .line-r::after {
                content: '';
                position: absolute;
                right: -4px;
                top: -7px;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                border: 1px solid #8d40ef;
            }

            .line-l, .line-r {
                position: absolute;
                /*left: 0;*/
                top: 28px;
                width: 100px;
                height: 1px;
                background: #8d40ef;
            }

            em {
                font-size: 14px;
                font-weight: normal;
                font-style: normal;
                font-family: 微软雅黑, "Microsoft YaHei";
                margin: 0px;
                padding: 0px;
                list-style: none;
            }

            .line-r {
                right: 0;
                left: initial;
            }

            .line-r::after {
                left: -5px;
                right: initial;
            }

        }

        /*菜单栏start*/
        .verticalMenu {
            .ivu-menu-light {
                background: #d9b2ff;
            }

            .ivu-menu {
                display: block;
                border-radius: 40px;
                overflow: hidden;
                color: #ffffff;
                font-size: 14px;
                position: relative;
            }

            .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
                color: #ffffff;
                font-weight: 600;
                background: rgb(153, 51, 255);
                z-index: 2;
            }

            .ivu-menu-vertical .ivu-menu-item:hover, .ivu-menu-vertical .ivu-menu-submenu-title:hover {
                color: #3d2404;
            }

            .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
                content: '';
                display: block;
                width: 2px;
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                background: #e5ea20;
            }
        }

        /*菜单栏end*/

        /*小标题start*/
        .title_head {
            color: #9933CC;
            font-weight: 600;
            font-size: 18px;
        }

        .lang_eng {
            /*color: rgb(255,165,51);*/
            font-size: 16px;
        }

        /*小标题end*/
    }
</style>
